import { IconButton, Tooltip } from "@mui/material";
import { LightMode as LightModeIcon, DarkMode as DarkModeIcon } from "@mui/icons-material";
import { useTema } from "../stores/temaStore";

/** Botón para alternar entre modo claro y oscuro. `color` adapta el ícono al fondo. */
export default function BotonTema({ color = "inherit" }: { color?: string }) {
  const modo = useTema((s) => s.modo);
  const alternar = useTema((s) => s.alternar);
  const oscuro = modo === "dark";
  return (
    <Tooltip title={oscuro ? "Modo claro" : "Modo oscuro"}>
      <IconButton onClick={alternar} size="small" sx={{ color }} aria-label="Cambiar tema">
        {oscuro ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
